export default __webpack_public_path__ + "static/media/carto-logo-map.5c7c203f.svg";